import { showInAWhileIntervalInMs } from './constants';

function isNextShowReached({
  currentTimeInMs,
  lastTimeClosedInMs,
}: {
  lastTimeClosedInMs: number | null;
  currentTimeInMs: number;
}) {
  const bannerHasClosed = lastTimeClosedInMs !== null;
  if (!bannerHasClosed) {
    return true;
  }

  const nextShowInMs = lastTimeClosedInMs + showInAWhileIntervalInMs;
  return currentTimeInMs > nextShowInMs;
}

export function shouldShowBanner({
  currentTimeInMs,
  isShowingStarted,
  lastTimeClosedInMs,
}: {
  isShowingStarted: boolean;
  lastTimeClosedInMs: number | null;
  currentTimeInMs: number;
}) {
  if (isShowingStarted && !isNextShowReached({ currentTimeInMs, lastTimeClosedInMs })) {
    return false;
  }

  return isShowingStarted;
}
